import { lazy, Suspense, useState } from "react";
import { MessageSquareHeart } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const FeedbackDialog = lazy(() =>
  import("@/components/FeedbackDialog").then((module) => ({ default: module.FeedbackDialog })),
);

export function FeedbackLauncher({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className={cn(className)}
        onClick={() => setOpen(true)}
      >
        <MessageSquareHeart className="size-4 text-primary" />
        Enviar feedback
      </Button>
      {open ? (
        <Suspense fallback={null}>
          <FeedbackDialog open={open} onOpenChange={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}